import type { User } from '../../api/types'
import { BotTag } from '../../components/BotTag'
import { isBotUser } from '../../lib/bots'
import { isPlaceholderUser } from '../../lib/managed'

/** A person's or bot's name, then what tells them apart: a bot's description, or someone's @username. */
export function PersonText({ user }: { user: User }) {
  return (
    <span className="person-text">
      <strong>
        {user.displayName}
        {isBotUser(user) ? <BotTag /> : null}
      </strong>
      <small>
        {isBotUser(user) ? (
          (user.description ?? `@${user.username}`)
        ) : (
          <>
            @{user.username}
            {isPlaceholderUser(user) ? ' · Not signed in yet' : ''}
          </>
        )}
      </small>
    </span>
  )
}
